import { isFlowTheme } from '../utils'

export const APP_FEEDBACK_EMAIL_ADDRESS = isFlowTheme ? 'beratung.em@hager.com' : 'app-feedback@e3dc.com'
export const APP_FEEDBACK_EMAIL_SUBJECT = isFlowTheme ? 'My Hager Feedback' : 'My E3/DC Feedback'
export const APP_FEEDBACK_EMAIL_HREF = `mailto:${APP_FEEDBACK_EMAIL_ADDRESS}?subject=${APP_FEEDBACK_EMAIL_SUBJECT}`

export const RATE_APP_CRITERIA_MET = 'rate-app-criteria-met'
export const FETCH_SYSTEM_LOG_STATS_FILTER = 'isResolved:IN(0) AND errorType:IN(ERROR)'

export const REMIND_ME_LATER_AFTER_BUTTON_CLICK_WEEKS_AMOUNT = 2
export const REMIND_ME_LATER_AFTER_RATING_MONTHS_AMOUNT = 6
export const REMIND_ME_LATER_AFTER_CLOSE_MONTHS_AMOUNT = 3
export const NUMBER_OF_DAYS_REQUIRED_SINCE_LAST_PORTAL_UPDATE = 5
export const RATE_APP_SEARCH_PARAMETER = 'rate-app'
export const IOS_APP_STORE_LINK = isFlowTheme
  ? 'https://apps.apple.com/app/hager-flow/id1632405147'
  : 'https://apps.apple.com/app/my-e3-dc/id6463873702'
export const ANDROID_APP_STORE_LINK = isFlowTheme
  ? 'https://play.google.com/store/apps/details?id=com.hagerenergy.flow'
  : 'https://play.google.com/store/apps/details?id=com.hagerenergy.e3dc'
